export default {"src":"/_next/static/media/playstore-icon.3554b012.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};